import {
  List,
  ListItem,
  ListItemIconSkeleton,
  ListItemTextSkeleton,
  PillSkeleton,
} from "@clipboard-health/ui-components";
import { Box, Skeleton, Stack } from "@mui/material";

import { PageHeaderTopRow } from "../../../components/PageHeaderTopRow";

interface ShiftBundleSheetSkeletonProps {
  onClose: () => void;
}

export function ShiftBundleSheetSkeleton(props: ShiftBundleSheetSkeletonProps) {
  const { onClose } = props;

  return (
    <>
      <Stack
        sx={(theme) => ({
          paddingTop: 6,
          paddingBottom: 7,
          paddingX: 5,
          background: theme.palette.shift?.bundle?.gradient,
        })}
        spacing={4}
      >
        <PageHeaderTopRow sx={{ paddingX: 0, paddingBottom: 3 }} onClickBack={onClose} />

        <Stack sx={{ paddingLeft: 3 }} spacing={4}>
          <Skeleton variant="text" width="60%" height={24} />
          <Skeleton variant="text" width="50%" height={32} />
          <PillSkeleton />
        </Stack>
      </Stack>

      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        <List sx={{ paddingX: 6 }}>
          <ListItem divider>
            <ListItemIconSkeleton />
            <ListItemTextSkeleton primaryWidth="60%" secondaryWidth="40%" />
          </ListItem>

          {[1, 2, 3].map((index) => (
            <ListItem key={index}>
              <ListItemIconSkeleton />
              <ListItemTextSkeleton primaryWidth="45%" secondaryWidth="35%" />
            </ListItem>
          ))}
        </List>
      </Box>
    </>
  );
}
